<template>
  <el-main>
    <div class="container">
      <div class="paper-info">
        <div class="paper-title">
          {{ paper.title }}
        </div>
        <div class="paper-intro">
          <div>
            ◇ 本卷共{{ paper.topics ? paper.topics.length : 0 }}道题，作答时间为 {{ paper.time }} 分钟，总分 {{
              paper.num
            }}
            分；
          </div>
          <div>
            ◇ 试卷来源：清瀚学堂
          </div>
          <div>
            ◇
            <span @click="printPaper">打印试卷</span>
          </div>
        </div>
        <div class="paper-progress">
          <el-progress :percentage="percentage" :format="format" :stroke-width="10"></el-progress>
        </div>
      </div>
      <div class="paper-body">
        <el-row :gutter="20">
          <el-col :span="18">
            <div class="paper-body-left">
              <div class="topic-list" v-if="topics && topics.length > 0">
                <div class="topic-item" v-for="(item, index) in paper.topics" :key="index" v-if="topicIndex === index">
                  <div class="topic-title">
                    <span>{{ index + 1 }}、</span>
                    <span>【{{ item.types.title }}】</span>
                    <span class="topic-html" v-html="item.title"></span>
                  </div>
                  <div class="topic-images" v-if="item.images && item.images.length > 0">
                    <img :src="path + img_i" alt="" v-for="(img_i, img_n) in item.images" :key="img_n"
                         class="topic-images-item">
                  </div>
                  <div class="topic-options">
                    <div class="topic-radio-box" v-if="item.types.type === 1">
                      <el-radio-group v-model="item.userAnswer" @change="changeRadio(item, index)">
                        <el-radio :label="r_n" v-for="(r_i, r_n) in item.options" v-if="r_i"
                                  class="topic-radio">
                          {{ r_n }}、<span class="topic-html" v-html="r_i"></span>
                        </el-radio>
                      </el-radio-group>
                    </div>
                    <div class="topic-checkbox-box" v-if="item.types.type === 2 || item.types.type === 4">
                      <el-checkbox-group v-model="item.userAnswer" @change="changeCheckbox(item, index)">
                        <el-checkbox :label="c_n" v-for="(c_i, c_n) in item.options" v-if="c_i"
                                     class="topic-checkbox">{{ c_n }}、<span class="topic-html" v-html="c_i"></span>
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <div class="topic-radio-box" v-if="item.types.type === 3">
                      <el-radio-group v-model="item.userAnswer" @change="changeRadio(item, index)">
                        <el-radio label="正确" class="topic-radio">正确</el-radio>
                        <el-radio label="错误" class="topic-radio">错误</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="topic-textarea-box" v-if="item.types.type === 6">
                      <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请输入答案"
                        @input="changeTextarea(item, index)"
                        v-model="item.userAnswer">
                      </el-input>
                    </div>
                    <div class="topic-parts-box" v-if="item.types.type === 5">
                      <div class="topic-list" v-if="item.parts && item.parts.length > 0">
                        <div class="topic-item" v-for="(i, n) in item.parts" :key="n">
                          <div class="topic-title parts-title">
                            <span>（{{ n + 1 }}）</span>
                            <span>【{{ i.types.title }}】</span>
                            <span class="topic-html" v-html="i.title"></span>
                          </div>
                          <div class="topic-images" v-if="i.images && i.images.length > 0">
                            <img :src="path + img_i" alt="" v-for="(img_i, img_n) in i.images" :key="img_n"
                                 class="topic-images-item">
                          </div>
                          <div class="topic-options">
                            <div class="topic-radio-box" v-if="i.types.type === 1">
                              <el-radio-group v-model="i.userAnswer" @change="changePartsRadio(item, index)">
                                <el-radio :label="r_n" v-for="(r_i, r_n) in i.options" v-if="r_i"
                                          class="topic-radio">
                                  {{ r_n }}、<span class="topic-html" v-html="r_i"></span>
                                </el-radio>
                              </el-radio-group>
                            </div>
                            <div class="topic-checkbox-box" v-if="i.types.type === 2 || i.types.type === 4">
                              <el-checkbox-group v-model="i.userAnswer" @change="changeCheckboxPart(item, index, i, n)">
                                <el-checkbox :label="c_n" v-for="(c_i, c_n) in i.options" v-if="c_i"
                                             class="topic-checkbox">{{ c_n }}、<span class="topic-html" v-html="c_i"></span>
                                </el-checkbox>
                              </el-checkbox-group>
                            </div>
                            <div class="topic-radio-box" v-if="i.types.type === 3">
                              <el-radio-group v-model="i.userAnswer" @change="changePartsRadio(item, index)">
                                <el-radio label="正确" class="topic-radio">正确</el-radio>
                                <el-radio label="错误" class="topic-radio">错误</el-radio>
                              </el-radio-group>
                            </div>
                            <div class="topic-textarea-box" v-if="i.types.type === 6">
                              <el-input
                                type="textarea"
                                :rows="5"
                                placeholder="请输入答案"
                                @input="changeTextarea(item, index)"
                                v-model="i.userAnswer">
                              </el-input>
                            </div>
                          </div>
                          <div class="topic-problem">
                            <el-link icon="el-icon-edit" :underline="false" @click="sendProblem(item.id, i.id)">答疑
                            </el-link>
                          </div>
                          <div class="topic-analysis" v-if="analysis">
                            <div>正确答案：
                              <span class="topic-analysis-answer" v-if="i.type !== 2 && i.type !== 4">{{
                                  i.answer
                                }}</span>
                              <span class="topic-analysis-answer" v-if="i.type === 2 || i.type === 4">{{
                                  getTypeAnswer(i.answer)
                                }}</span>
                            </div>
                            <div class="topic-analysis-body">
                              <div>解析：</div>
                              <div class="topic-analysis-body">
                                <el-button type="primary" plain size="small" @click="showAiAnalysis(item.id, i.id)"
                                           v-if="!i.analysisShow">
                                  查看解析
                                </el-button>
                                <type-writer :ref="'topic_part_' + i.id" :key="'topic_part_' + i.id" :speed="50"
                                             v-if="i.analysisShow && !i.analysisEnd">
                                </type-writer>
                                <span v-if="i.analysisEnd">
                                  {{ i.analysisBody }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="topic-problem" v-if="item.types.type !== 5">
                    <el-link icon="el-icon-edit" :underline="false" @click="sendProblem(item.id, '')">答疑</el-link>
                  </div>
                  <div class="topic-analysis" v-if="analysis && item.types.type !== 5">
                    <div>正确答案：
                      <span class="topic-analysis-answer" v-if="item.types.type !== 2 && item.types.type !== 4">{{
                          item.answer
                        }}</span>
                      <span class="topic-analysis-answer"
                            v-if="item.types.type === 2 || item.types.type === 4">{{
                          getTypeAnswer(item.answer)
                        }}</span>
                    </div>
                    <div class="topic-analysis-body">
                      <div>解析：</div>
                      <div class="topic-analysis-body">
                        <el-button type="primary" plain size="small" @click="showAiAnalysis(item.id)"
                                   v-if="!item.analysisShow">
                          查看解析
                        </el-button>
                        <type-writer :ref="'topic_' + item.id" :key="'topic_' + item.id" :speed="50"
                                     v-if="item.analysisShow && !item.analysisEnd">
                        </type-writer>
                        <span v-if="item.analysisEnd">
                          {{ item.analysisBody }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="topic-nav">
                <el-button-group class="topic-nav-list">
                  <el-button class="topic-nav-item" icon="el-icon-arrow-left" @click="moveTopic(-1)">
                    上一题
                  </el-button>
                  <el-button class="topic-nav-item" icon="el-icon-document-checked"
                             @click="showAnalysis">
                    <span v-if="!analysis">查看答案</span>
                    <span v-if="analysis">关闭答案</span>
                  </el-button>
                  <!--                  <el-button class="topic-nav-item" icon="el-icon-edit"-->
                  <!--                             @click="sendProblem">答疑-->
                  <!--                  </el-button>-->
                  <el-button class="topic-nav-item" @click="moveTopic(1)">下一题<i
                    class="el-icon-arrow-right el-icon--right"></i></el-button>
                </el-button-group>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="paper-body-right">
              <div class="paper-card">
                答题卡
              </div>
              <div class="paper-card-body">
                <div class="paper-card-box" v-for="(card, cardIndex) in cardList" :key="cardIndex">
                  <div class="paper-card-title">
                    {{ card[0].types.title }}
                  </div>
                  <div class="paper-card-list">
                    <div class="paper-card-item" v-for="(item, index) in card" :key="index">
                      <el-button class="topic-button" v-if="item.types.type !== 5"
                                 :class="[item.userAnswer.length > 0 ? 'current' : '', result ? comparison(item.userAnswer, item.answer, item.types.type) : '']"
                                 @click="goSwiper(item.index)">
                        {{ item.index + 1 }}
                      </el-button>
                      <el-button class="topic-button" v-if="item.types.type === 5" v-for="(i, n) in item.parts" :key="n"
                                 :class="[i.userAnswer.length > 0 ? 'current' : '', result ? comparison(i.userAnswer, i.answer, i.types.type) : '']"
                                 @click="goSwiper(item.index)">
                        {{ item.index + 1 }}-{{ n + 1 }}
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="paper-test">
                <div class="paper-label">
                  <div class="paper-label-item">未答</div>
                  <div class="paper-label-item paper-label-success">已答</div>
                  <div class="paper-label-item paper-label-error">
                    错误
                    <el-tooltip content="交卷后可查看错误题目" placement="top-start">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-button type="primary" class="test-button" @click="goTest">交卷</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      title="试题答题"
      :visible.sync="showProblem"
      width="30%"
      center>
      <el-input
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 8}"
        placeholder="请输入答疑内容"
        v-model="problem">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showProblem = false">取 消</el-button>
        <el-button type="primary" @click="confirmProblem">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="考试结果"
      :visible.sync="showResult"
      width="30%"
      center>
      <div class="success">
        <i class="el-icon-success success-icon"></i>
        <div class="success-title">答题完成</div>
        <div class="success-info-box">
          <div class="success-info">
            <div>得分：{{ result.num }}</div>
            <div>答题时长：{{ SecondToDate(result.time) }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import {authRequest} from "@/utils/request";
import date from "@/utils/date"
import TypeWriter from "@/components/type-writer/type-writer.vue"

export default {
  name: "studyTest",
  head() {
    return {
      title: '在线答题'
    }
  },
  components: {
    TypeWriter
  },
  data() {
    return {
      id: '',
      paper: '',
      percentage: 0,
      topicIndex: 0,
      path: process.env.VUE_APP_FILE,
      topics: [],
      analysis: false,
      now: '',
      showProblem: false,
      problem: '',
      showResult: false,
      result: '',
      problem_id: '',
      problem_part_id: '',
      cardList: [],
      analysisLoading: false
    }
  },
  created() {
    this.id = this.$route.params.id
    this.getPaper()
    this.now = date.currentTime('str')
  },
  watch: {
    topics(value) {
      let number = 0
      value.forEach((item, index) => {
        if (item.types.type !== 5) {
          if (item.userAnswer !== '' && item.userAnswer.length > 0) {
            number += 1
          }
        } else {
          let partsNumber = 0
          item.parts.forEach((i, n) => {
            if (i.userAnswer !== '' && i.userAnswer.length > 0) {
              partsNumber += 1
            }
          })
          number += partsNumber / item.parts.length
        }
      })
      this.percentage = number / value.length * 100 || 0

      this.setTestLog()
    }
  },
  methods: {
    printPaper() {
      this.$router.push({
        path: '/print/' + this.id
      })
    },
    async showAiAnalysis(topic_id, part_id = null) {
      this.analysisLoading = true;

      const topic = this.topics[this.topicIndex];

      // 初始化分析内容
      if (!topic.analysisBody) this.$set(topic, 'analysisBody', '');
      this.$set(topic, 'analysisShow', true);

      // 拼接消息
      let message = '';
      message += '题型为：' + topic.types.title + '\n';
      message += '题目为：' + topic.title + '\n';

      if ([1, 2, 4].includes(topic.type)) {
        const optionsStr = Object.entries(topic.options)
          .map(([k, v]) => `${k}: ${v}`)
          .join(', ');
        message += '选项有：' + optionsStr + '\n';
      }

      if (topic.answer) {
        const answerStr = Array.isArray(topic.answer) ? topic.answer.join(', ') : topic.answer.toString();
        if (answerStr.trim()) message += '答案为：' + answerStr + '\n';
      }

      let part, partIndex;
      if (part_id) {
        partIndex = topic.parts.findIndex(item => item.id === part_id);
        part = topic.parts[partIndex];
        if (!part.analysisBody) this.$set(part, 'analysisBody', '');
        this.$set(topic.parts[partIndex], 'analysisShow', true);

        message += '材料子题目为：' + part.title + '\n';

        if ([1, 2, 4].includes(part.type)) {
          const optionsStr = Object.entries(part.options)
            .map(([k, v]) => `${k}: ${v}`)
            .join(', ');
          message += '选项有：' + optionsStr + '\n';
        }

        if (part.answer) {
          const answerStr = Array.isArray(part.answer) ? part.answer.join(', ') : part.answer.toString();
          if (answerStr.trim()) message += '答案为：' + answerStr + '\n';
        }
      }

      // 获取 TypeWriter 组件引用
      const refsId = part_id ? 'topic_part_' + part_id : 'topic_' + topic.id;
      await this.$nextTick();
      const typewriter = this.$refs[refsId][0];

      const socket = new WebSocket('wss://ai.qhzyjy.com/');

      // 连接打开
      socket.onopen = () => {
        socket.send(JSON.stringify({
          message,
          id: this.id,
          subclass_id: topic.subclass_id,
        }));
      };

      // 接收消息
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);

        if (data.result) {
          if (!part_id) {
            topic.analysisBody += data.result;
          } else {
            part.analysisBody += data.result;
          }

          // 实时追加 TypeWriter
          typewriter.appendText(data.result);
        }

        if (data.is_end) {
          this.analysisLoading = false;
          if (!part_id) {
            this.$set(topic, 'analysisEnd', true);
          } else {
            this.$set(part, 'analysisEnd', true);
          }
          socket.close();
        }

        if (data.error) {
          this.analysisLoading = false;
          socket.close();
        }
      };

      // 连接错误
      socket.onerror = (err) => {
        this.analysisLoading = false;
      };

      // 连接关闭
      socket.onclose = () => {
      };
    },
    async getTestLog() {
      try {
        const response = await authRequest('testLog/' + this.id, {
          method: 'GET'
        })
        let log = response.data
        if (!log) {
          return false
        }
        this.$confirm('您上次答题没有结束，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(async () => {
          if (this.topics.length <= 0) {
            return false
          }
          if (log.index <= this.topics.length) {
            this.topicIndex = log.index
          } else {
            this.topicIndex = 0
          }
          this.topics.forEach(item => {
            if (item.types.type !== 5) {
              item.userAnswer = this.getAnswer(item.id, item.types.type, log.answers)
            } else {
              if (item.parts.length > 0) {
                item.parts.forEach(i => {
                  i.userAnswer = this.getAnswer(item.id, item.types.type, log.answers, i.id, i.type)
                })
              }
            }
          })
        }).catch(() => {

        });
      } catch (e) {

      }
    },
    getAnswer(id, type, arr, part_id = '', i_type) {
      let answer = ''
      if (type === 2 || type === 4 || i_type === 2 || i_type === 4) {
        answer = []
      }
      let index = arr.findIndex(item => item.id === id)
      if (index >= 0) {
        if (part_id) {
          let n = arr[index].answer.findIndex(i => i.id === part_id)
          if (n >= 0) {
            answer = arr[index].answer[n].answer
          }
        } else {
          answer = arr[index].answer
        }
      }
      return answer
    },
    async setTestLog() {
      if (this.topics.length <= 0) {
        return false
      }
      let answers = []
      this.topics.forEach(item => {
        if (item.types.type !== 5) {
          if (item.types.type === 2 || item.types.type === 4) {
            if (item.userAnswer.length > 0) {
              answers.push({
                id: item.id,
                type: item.types.type,
                answer: item.userAnswer
              })
            }
          } else if (item.userAnswer) {
            answers.push({
              id: item.id,
              type: item.types.type,
              answer: item.userAnswer
            })
          }
        } else {
          if (item.parts.length > 0) {
            let iAnswers = []
            item.parts.forEach(i => {
              if (i.type === 2 || i.type === 4) {
                if (i.userAnswer.length > 0) {
                  iAnswers.push({
                    id: i.id,
                    type: i.type,
                    answer: i.userAnswer
                  })
                }
              } else if (i.userAnswer) {
                iAnswers.push({
                  id: i.id,
                  type: i.type,
                  answer: i.userAnswer
                })
              }
            })
            if (iAnswers.length > 0) {
              answers.push({
                id: item.id,
                type: item.types.type,
                answer: iAnswers
              })
            }
          }
        }
      })
      if (answers.length > 0) {
        let test_log = {
          index: this.topicIndex,
          answers: answers
        }
        try {
          const response = await authRequest('testLog', {
            method: 'POST',
            data: {
              test_log: test_log,
              id: this.id
            }
          })
        } catch (e) {

        }
      }
    },
    async getPaper() {
      try {
        let response = await authRequest('paper/' + this.id, {
          method: 'GET'
        })
        this.paper = response.data.data
        if (this.paper.topics) {
          let topics = this.paper.topics
          topics.forEach((item, index) => {
            item.userAnswer = ''
            if (item.types.type === 2 || item.types.type === 4) {
              item.userAnswer = []
            }
            if (item.types.type === 5 && item.parts.length > 0) {
              item.parts.forEach((i, n) => {
                i.userAnswer = ''
                if (i.type === 2 || i.type === 4) {
                  i.userAnswer = []
                }
              })
            }
          })
          topics.sort((a, b) => {
            if (a.types.order === b.types.order) {
              if (!a.outline || !a.outline.order) {
                a.outline = {
                  order: 999999
                }
              }
              if (!b.outline || !b.outline.order) {
                b.outline = {
                  order: 999999
                }
              }
              return a.outline.order - b.outline.order
            }
            return a.types.order - b.types.order
          })

          this.cardList = this.groupBy(topics, topic => {
            return topic.types.order
          })
          this.topics = topics

          // 获取答题记录
          this.getTestLog()
        }
      } catch (e) {

      }
    },
    format(percentage) {
      return percentage === 100 ? '完成' : `${parseInt(percentage)}%`;
    },
    moveTopic(e) {
      if (e === -1) {
        if (this.topicIndex === 0) {
          this.$message.warning('已经是第一题啦～')
        } else {
          this.topicIndex -= 1;
        }
      }
      if (e === 1) {
        if (this.topicIndex < this.topics.length - 1) {
          this.topicIndex += 1;
        } else {
          this.$message.warning('已经是最后一题啦～')
        }
      }
    },
    changeRadio(item, index) {
      this.$set(this.topics, index, item)
      if (this.topicIndex < this.topics.length - 1) {
        this.topicIndex += 1;
      }
    },
    changeCheckbox(item, index) {
      item.userAnswer = item.userAnswer.sort()
      this.$set(this.topics, index, item)
    },
    changeCheckboxPart(item, index, i, n) {
      item.parts[n].userAnswer = i.userAnswer.sort()
      this.$set(this.topics, index, item)
    },
    changeTextarea(item, index) {
      this.$set(this.topics, index, item)
    },
    showAnalysis() {
      this.analysis = !this.analysis
    },
    getTypeAnswer(value) {
      if (!value) {
        return ''
      }
      let result = []
      for (let i = 0; i < value.length; i++) {
        if (value[i]) {
          result.push(value[i])
        }
      }
      return result.toString()
    },
    changePartsRadio(item, index) {
      this.$set(this.topics, index, item)
    },
    goSwiper(index) {
      this.topicIndex = index
    },
    goTest() {
      if (this.result) {
        this.$message.info('您已经交过卷了，若想继续答题请刷新页面！')
        return false
      }
      let title = ''
      if (this.percentage < 100) {
        title = '您还没有做完题目，当前进度' + parseInt(this.percentage) + '%，是否确认交卷？'
      } else {
        title = '是否确认交卷？'
      }
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        this.goScore()
      }).catch(() => {

      });
    },
    sendProblem(id, part_id) {
      this.problem_id = id
      this.problem_part_id = part_id
      this.showProblem = true
    },
    async confirmProblem() {
      if (!this.problem) {
        this.$message.warning('请输入答疑内容')
        return false
      }
      try {
        let response = await authRequest('paper/problem', {
          method: 'POST',
          data: {
            problem: this.problem,
            id: this.problem_id,
            part_id: this.problem_part_id,
            paper_id: this.id
          }
        })
        if (response.status === 201) {
          this.showProblem = false
          this.problem = ''
          this.$message.success('答疑已提交')
        }
      } catch (e) {

      }
    },
    async goScore() {
      const loading = this.$loading({
        lock: true,
        text: '正在计算中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let test = this.topics
      let errorList = []
      let num = 0
      let correct = 0
      let total = 0
      let write = 0
      let error = 0
      test.forEach((item, index) => {
        // if (item.userAnswer !== '' && item.types.type !== 5) {
        if (item.types.type !== 5) {
          total++
          if (item.userAnswer !== '') {
            write++
            if (item.types.type === 1) {
              if (item.userAnswer === item.answer) {
                num += Number(this.paper.score_1)
                correct++
              } else {
                errorList.push({
                  topic_id: item.id,
                  part_id: null,
                  paper_id: this.id
                })
                error++
              }
            }
            if (item.types.type === 2 && item.userAnswer.length > 0) {
              let answer = []
              item.answer.forEach((i, n) => {
                if (i) {
                  answer.push(i)
                }
              })
              if (answer.toString() === item.userAnswer.toString()) {
                num += Number(this.paper.score_2)
                correct++
              } else {
                errorList.push({
                  topic_id: item.id,
                  part_id: null,
                  paper_id: this.id
                })
                error++
              }
            }
            if (item.types.type === 3) {
              if (item.userAnswer === item.answer) {
                num += Number(this.paper.score_3)
                correct++
              } else {
                errorList.push({
                  topic_id: item.id,
                  part_id: null,
                  paper_id: this.id
                })
                error++
              }
            }
            if (item.types.type === 4 && item.userAnswer.length > 0) {
              let answer = []
              item.answer.forEach((i, n) => {
                if (i) {
                  answer.push(i)
                }
              })
              if (answer.toString() === item.userAnswer.toString()) {
                num += Number(this.paper.score_7)
                correct++
              } else {
                errorList.push({
                  topic_id: item.id,
                  part_id: null,
                  paper_id: this.id
                })
                error++
              }
            }
          }
        }
        if (item.types.type === 5) {
          let parts = item.parts
          parts.forEach((i, n) => {
            total++
            if (i.userAnswer !== '') {
              write++
              if (i.type === 1) {
                if (i.userAnswer === i.answer) {
                  num += Number(this.paper.score_4)
                  correct++
                } else {
                  errorList.push({
                    topic_id: item.id,
                    part_id: i.id,
                    paper_id: this.id
                  })
                  error++
                }
              }
              if (i.types.type === 2 && i.userAnswer.length > 0) {
                let answer = []
                i.answer.forEach((ii, nn) => {
                  if (ii) {
                    answer.push(ii)
                  }
                })
                if (answer.toString() === i.userAnswer.toString()) {
                  num += Number(this.paper.score_5)
                  correct++
                } else {
                  errorList.push({
                    topic_id: item.id,
                    part_id: i.id,
                    paper_id: this.id
                  })
                  error++
                }
              }
              if (i.types.type === 3) {
                if (i.userAnswer === i.answer) {
                  num += Number(this.paper.score_6)
                  correct++
                } else {
                  errorList.push({
                    topic_id: item.id,
                    part_id: i.id,
                    paper_id: this.id
                  })
                  error++
                }
              }
              if (i.types.type === 4 && i.userAnswer.length > 0) {
                let answer = []
                i.answer.forEach((ii, nn) => {
                  if (ii) {
                    answer.push(ii)
                  }
                })
                if (answer.toString() === i.userAnswer.toString()) {
                  num += Number(this.paper.score_8)
                  correct++
                } else {
                  errorList.push({
                    topic_id: item.id,
                    part_id: i.id,
                    paper_id: this.id
                  })
                  error++
                }
              }
            }
          })
        }
      })
      try {
        let response = await authRequest('paper/test', {
          method: 'POST',
          data: {
            id: this.id,
            error: errorList,
            num: num,
            time: this.now,
            correct: correct,
            write: write,
            total: total,
            wrong: error
          }
        })
        if (response.status === 201) {
          loading.close()
          this.getResult(response.data.data.id)
          // this.$router.push({path: '/test/result/success', query: {id: response.data.data.id}})
        }
      } catch (e) {
        loading.close()
      }
    },
    async getResult(id) {
      try {
        let response = await authRequest('test/' + id, {
          method: 'GET'
        })
        this.result = response.data.data
        this.showResult = true
        this.analysis = true
      } catch (e) {

      }
    },
    SecondToDate(msd) {
      var time = msd
      if (null != time && "" !== time) {
        if (time > 60 && time < 60 * 60) {
          time = parseInt(time / 60.0) + "分钟" + parseInt((parseFloat(time / 60.0) -
            parseInt(time / 60.0)) * 60) + "秒";
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          time = parseInt(time / 3600.0) + "小时" + parseInt((parseFloat(time / 3600.0) -
              parseInt(time / 3600.0)) * 60) + "分钟" +
            parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
              parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
        } else if (time >= 60 * 60 * 24) {
          time = parseInt(time / 3600.0 / 24) + "天" + parseInt((parseFloat(time / 3600.0 / 24) -
              parseInt(time / 3600.0 / 24)) * 24) + "小时" + parseInt((parseFloat(time / 3600.0) -
              parseInt(time / 3600.0)) * 60) + "分钟" +
            parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
              parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
        } else {
          time = parseInt(time) + "秒";
        }
      }
      return time;
    },
    comparison(userAnswer, answer, type) {
      if (type === 1 && userAnswer) {
        if (userAnswer !== answer) {
          return 'answer-error'
        }
      }
      if (type === 2 && userAnswer.length > 0) {
        let answer_r = []
        answer.forEach((ii, nn) => {
          if (ii) {
            answer_r.push(ii)
          }
        })
        if (answer_r.toString() !== userAnswer.toString()) {
          return 'answer-error'
        }
      }
      if (type === 4 && userAnswer.length > 0) {
        let answer_r = []
        answer.forEach((ii, nn) => {
          if (ii) {
            answer_r.push(ii)
          }
        })
        if (answer_r.toString() !== userAnswer.toString()) {
          return 'answer-error'
        }
      }
      if (type === 3 && userAnswer) {
        if (userAnswer !== answer) {
          return 'answer-error'
        }
      }
    },
    groupBy(list, fn) {
      const groups = {};
      list.forEach((item, index) => {
        item.index = index
        const group = JSON.stringify(fn(item));
        groups[group] = groups[group] || [];
        groups[group].push(item);
      });

      return groups;
    }
  }
}
</script>

<style scoped>
.paper-info {
  background-color: #ffffff;
  padding: 0 20px;
  border-radius: 6px;
}

.paper-title {
  line-height: 60px;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  border-bottom: 1px dashed #ebebeb;
}

.paper-intro {
  padding: 10px 0;
  border-bottom: 1px dashed #ebebeb;
}

.paper-progress {
  padding: 20px 0;
}

.paper-body {
  margin-top: 20px;
}

.paper-body-left, .paper-body-right {
  overflow: hidden;
  border-radius: 6px;
  background-color: #ffffff;
}

.topic-title {
  border-bottom: 1px dashed #ebebeb;
  padding: 20px;
  border-left: 3px solid #2aacb2;
}

.topic-html img {
  max-width: 100%;
}

.topic-images {
  padding: 20px;
  border-bottom: 1px dashed #ebebeb;
}

.topic-images-item {
  width: 100%;
  margin-right: 10px;
}

.topic-nav {
  margin-top: 30px;
}

.topic-nav-list {
  display: flex;
  justify-content: space-between;
}

.topic-nav-item {
  width: 33.33%;
}

.topic-options {
  padding: 20px;
}

.topic-radio, .topic-checkbox {
  width: 100%;
  margin-bottom: 15px;
  white-space: normal;
}

.topic-radio:last-child, .topic-checkbox:last-child {
  margin-bottom: 0;
}

.topic-analysis {
  border-top: 1px dashed #ebebeb;
  padding: 20px;
}

.topic-analysis-body {
  margin-top: 10px;
}

.topic-analysis-answer {
  font-size: 18px;
  color: #2aacb2;
  font-weight: 500;
}

.parts-title {
  background-color: #f3f3f3;
  padding: 10px;
  border-left: 0;
}

.paper-card {
  padding: 20px;
  border-left: 3px solid #2aacb2;
  border-bottom: 1px dashed #ebebeb;
}

.paper-card-body {
  padding: 20px;
  border-bottom: 1px dashed #ebebeb;
}

.paper-card-item {
  display: inline-block;
}

.topic-button {
  width: 50px;
  height: 35px;
  display: inline-block;
  line-height: 35px;
  margin: 5px;
  border-radius: 6px;
  color: #454548;
  padding: 0;
}

.topic-button.current {
  background-color: #2aacb2;
  color: #ffffff;
  border-color: #2aacb2;
}

.topic-button.answer-error {
  background-color: #F56C6C;
  color: #ffffff;
  border-color: #F56C6C;
}

.paper-test {
  padding: 20px;
}

.test-button {
  width: 100%;
}

.success {
  text-align: center;
  background-color: #ffffff;
  border-radius: 6px;
  padding: 30px;
}

.success-title {
  color: #333333;
  font-weight: bold;
  font-size: 20px;
}

.success-button {
  margin-top: 30px;
}

.success-icon {
  font-size: 100px;
  color: #2aacb2;
}

.success-info-box {
  display: flex;
  justify-content: center;
}

.success-info {
  background-color: #f3f3f3;
  margin-top: 30px;
  width: 600px;
  padding: 20px;
  border-radius: 6px;
  text-align: left;
}

.paper-label {
  display: flex;
  justify-content: space-around;
  margin-bottom: 10px;
  align-items: center;
}

.paper-label-item::before {
  content: '';
  display: inline-block;
  margin-right: 5px;
  width: 12px;
  height: 12px;
  border: 1px solid #ebebeb;
  background-color: #ffffff;
  box-sizing: border-box;
  border-radius: 2px;
}

.paper-label-item.paper-label-success::before {
  background-color: #2aacb2;
  border: #2aacb2;
}

.paper-label-item.paper-label-error::before {
  background-color: #F56C6C;
  border: #F56C6C;
}

.paper-label-error .el-icon-info {
  color: #6e6e6e;
}

.topic-problem {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
}

.paper-card-title {
  height: 35px;
  display: flex;
  align-items: center;
  background-color: #f3f3f3;
  margin-bottom: 10px;
  border-left: 3px solid #2aacb2;
  padding-left: 12px;
}

.paper-card-box {
  margin-bottom: 10px;
}

.paper-card-box:last-child {
  margin-bottom: 0;
}
</style>
